import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {DataCollectionStatus} from "../servers/server.model";
import {SecurityUtils} from "../auth/security.utils";
import {HealthStatus} from "../applications/new-application.model";
import {Injectable, inject} from "@angular/core";
import {Organization} from "../organizations/organization.service";

@Injectable({providedIn: 'root'})
export class WorkstationConfigurationService {
	private httpClient = inject(HttpClient);

	private backendUrl = (tenantId: string) => `${environment.engineURL}/tenants/${tenantId}/workstation-configuration`;

	getWorkstationConfiguration(tenantId: string, workstationId: string): Observable<WorkstationConfiguration> {
		return this.httpClient.get<WorkstationConfiguration>(`${this.backendUrl(tenantId)}/${workstationId}`, {
			headers: SecurityUtils.getAuthHttpHeaders()
		});
	}

	getWorkstationConfigurationUsers(tenantId: string, workstationId: string): Observable<WorkstationUser[]> {
		return this.httpClient.get<WorkstationUser[]>(`${this.backendUrl(tenantId)}/${workstationId}/users`, {
			headers: SecurityUtils.getAuthHttpHeaders()
		});
	}

	getTenantWorkstationConfiguration(tenantId: string): Observable<WorkstationConfiguration[]> {
		return this.httpClient.get<WorkstationConfiguration[]>(`${this.backendUrl(tenantId)}`, {
			headers: SecurityUtils.getAuthHttpHeaders(),
		});
	}

	getTenantWorkstationCount(tenantId: string): Observable<number> {
		return this.httpClient.get<number>(`${this.backendUrl(tenantId)}/count`, {
			headers: SecurityUtils.getAuthHttpHeaders(),
		});
	}

	getWorkstationExportData(tenantId: string, workstationIds?: string[]): Observable<WorkstationConfiguration[]> {
		const body = workstationIds ? { workstationIds } : {};
		return this.httpClient.post<WorkstationConfiguration[]>(`${this.backendUrl(tenantId)}/exports`, body, {
			headers: SecurityUtils.getAuthHttpHeaders(),
		});
	}
}

export interface WorkstationConfiguration {
	id: string
	structureId: string
	teamId: string
	hostname: string
	userId: string
	userRealName: string | null
	userAccount: string | null
	health: HealthStatus
	bootUpTime: number | null
	uptime: number
	laptop: boolean
	manufacturer: string | null
	workstationModel: string | null
	serialNumber: string | null
	privateIp: string | null
	externalIp: string | null
	load: number
	lastCollectDate: string
	collectStatus: DataCollectionStatus
	osModel: string
	osVersion: string
	osName: string
	cpuUsed: number
	ramUsed: number
	storageUsed: number | null
	batteryHealth: number | null
	storageLoad: number | null
	isFirewallEnabled: boolean | null,
	isEncryptionEnabled: boolean | null,
	isEdrEnabled: boolean | null
}

export interface WorkstationUser {
	userId: string,
	userRealName: string | null,
	team: Organization | null
}

export type WorkstationExportCsv = Record<string, string>;
